import React, { Suspense } from 'react';

import {
  RestaurantProvider,
  OrderProvider,
  LiveOrderProvider,
  CartProvider,
  LikesProvider,
  FoodDataProvider,
  useRestaurant,
} from '../../core';
import LoadingScreen from '../shared/components/LoadingScreen';
import { getThemeLoader } from '../../themes/registry';

const themeCache = {};

function getThemeComponent(restaurantId, themeId, themeType, customThemeSlug) {
  const cacheKey = `${restaurantId || ''}:${themeType}:${themeId}:${customThemeSlug || ''}`;
  if (!themeCache[cacheKey]) {
    themeCache[cacheKey] = React.lazy(
      getThemeLoader({ restaurantId, themeId, themeType, customThemeSlug }),
    );
  }
  return themeCache[cacheKey];
}

function ThemeOutlet() {
  const { restaurantId, themeId, themeType, customThemeSlug } = useRestaurant();
  const Theme = getThemeComponent(restaurantId, themeId, themeType, customThemeSlug);
  const themeKey = `${restaurantId || ''}:${themeType || 'platform'}:${themeId || 'a'}:${customThemeSlug || ''}`;
  return (
    <Suspense fallback={<LoadingScreen message="Loading..." />}>
      <Theme key={themeKey} />
    </Suspense>
  );
}

const CustomerApp = () => {
  return (
    <RestaurantProvider>
      <OrderProvider>
        <CartProvider>
          <LiveOrderProvider>
            <LikesProvider>
              <FoodDataProvider>
                <ThemeOutlet />
              </FoodDataProvider>
            </LikesProvider>
          </LiveOrderProvider>
        </CartProvider>
      </OrderProvider>
    </RestaurantProvider>
  );
};

export default CustomerApp;
